export default "__VITE_ASSET__166868a8__"